import React, { useEffect, useState } from "react";
import { Introduction } from "../components/introduction/Introduction";
import { MissionVision } from "../components/introduction/MissionVision";
import { History } from "../components/introduction/History";
import Banner from "../components/Banner";
import { Trustees } from "../components/introduction/Trustees";
import { useLocation } from "react-router-dom";
import { dynamicFailed } from "../hooks/custom/useToast";
import {
  fetchAboutBot,
  fetchAboutExOfficioMembers,
  fetchAboutHistory,
  fetchAboutIntroduction,
  fetchAboutJoinUs,
  fetchAboutWhoUnepalFor,
  fetchAboutWhyUnepal,
  fetchBotDescription,
  fetchCoreValuesPoints,
  fetchCoreValuesStatement,
  fetchMission,
  fetchVision,
} from "../api/AboutApi";
import {
  IAboutBotData,
  IAboutExOfficioMembersData,
  IAboutHistoryData,
  IAboutIntroductionData,
  IAboutJoinUsData,
  IAboutWhoUnepalForData,
  IAboutWhyUnepalData,
  IBotDescriptionData,
  IChancellorMessageData,
  ICoreValuesPointsData,
  ICoreValuesStatementData,
  IMissionVisionData,
} from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";
import { Message } from "../components/home/Message";
import {
  fetchChancellorMessage,
  fetchViceChancellorMessage,
} from "../api/HomeApi";

const IntroductionPage = () => {
  const location = useLocation();

  const { setLoading } = useLoader();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname, location.hash]);

  const [aboutIntroduction, setAboutIntroduction] = useState<
    IAboutIntroductionData[]
  >([]);
  const [aboutWhyUnepal, setAboutWhyUnepal] = useState<IAboutWhyUnepalData[]>(
    [],
  );
  const [aboutWhoUnepalFor, setAboutWhoUnepalFor] = useState<
    IAboutWhoUnepalForData[]
  >([]);
  const [aboutJoinUs, setAboutJoinUs] = useState<IAboutJoinUsData[]>([]);
  const [chancellorMessage, setChancellorMessage] = useState<
    IChancellorMessageData[]
  >([]);
  const [viceChancellorMessage, setViceChancellorMessage] = useState<
    IChancellorMessageData[]
  >([]);
  const [visionStatement, setVisionStatement] = useState<IMissionVisionData[]>(
    [],
  );
  const [missionStatement, setMissionStatement] = useState<
    IMissionVisionData[]
  >([]);
  const [coreValuesStatement, setCoreValuesStatement] = useState<
    ICoreValuesStatementData[]
  >([]);
  const [coreValuesPoints, setCoreValuesPoints] = useState<
    ICoreValuesPointsData[]
  >([]);
  const [aboutHistory, setAboutHistory] = useState<IAboutHistoryData[]>([]);
  const [aboutBot, setAboutBot] = useState<IAboutBotData[]>([]);
  const [aboutExOfficioMembers, setAboutExOfficioMembers] = useState<
    IAboutExOfficioMembersData[]
  >([]);
  const [botDescription, setBotDescription] = useState<IBotDescriptionData[]>(
    [],
  );

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchAboutIntroduction(),
      fetchAboutWhyUnepal(),
      fetchAboutWhoUnepalFor(),
      fetchAboutJoinUs(),
      fetchChancellorMessage(),
      fetchViceChancellorMessage(),
      fetchVision(),
      fetchMission(),
      fetchCoreValuesStatement(),
      fetchCoreValuesPoints(),
      fetchAboutHistory(),
      fetchAboutBot(),
      fetchAboutExOfficioMembers(),
      fetchBotDescription(),
    ])
      .then(
        ([
          aboutIntroductionData,
          aboutWhyUnepalData,
          aboutWhoUnepalForData,
          aboutJoinUsData,
          chancellorMessageData,
          viceChancellorMessageData,
          visionStatementData,
          missionStatementData,
          coreValuesStatementData,
          coreValuesPointsData,
          aboutHistoryData,
          aboutBotData,
          aboutExOfficioMembersData,
          botDescriptionData,
        ]) => {
          setAboutIntroduction(aboutIntroductionData);
          setAboutWhyUnepal(aboutWhyUnepalData);
          setAboutWhoUnepalFor(aboutWhoUnepalForData);
          setAboutJoinUs(aboutJoinUsData);
          setChancellorMessage(chancellorMessageData);
          setViceChancellorMessage(viceChancellorMessageData);
          setVisionStatement(visionStatementData);
          setMissionStatement(missionStatementData);
          setCoreValuesStatement(coreValuesStatementData);
          setCoreValuesPoints(coreValuesPointsData);
          setAboutHistory(aboutHistoryData);
          setAboutBot(aboutBotData);
          setAboutExOfficioMembers(aboutExOfficioMembersData);
          setBotDescription(botDescriptionData);
        },
      )
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="About" />
      <Introduction
        aboutIntroduction={aboutIntroduction}
        aboutWhyUnepal={aboutWhyUnepal}
        aboutWhoUnepalFor={aboutWhoUnepalFor}
        aboutJoinUs={aboutJoinUs}
      />
      <Message
        chancellorMessage={chancellorMessage}
        viceChancellorMessage={viceChancellorMessage}
      />
      <MissionVision
        visionStatement={visionStatement}
        missionStatement={missionStatement}
        coreValuesStatement={coreValuesStatement}
        coreValuesPoints={coreValuesPoints}
      />
      <History aboutHistory={aboutHistory} />
      <Trustees
        aboutBot={aboutBot}
        aboutExOfficioMembers={aboutExOfficioMembers}
        botDescription={botDescription}
      />
    </>
  );
};

export default IntroductionPage;
